import React, { useEffect, useState } from "react";
import L from "leaflet"; // Импорт библиотеки Leaflet
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet/dist/leaflet.css";
import { MapContainer, Marker, Popup, TileLayer, GeoJSON } from "react-leaflet";
import { getCookie } from "typescript-cookie";
import KyLokal from "../../changeLang/drawLocalesKy";
import RuLokal from "../../changeLang/drawLocalesRu";
import styles from "./styles_map.module.css";

interface IContentPart {
    latitude: number;
    longitude: number;
}

const markers = [
    {
        latitude: 42.861677,

        longitude: 74.361614,
        tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Агропродукт Азия»</h3>
      <p style="margin: 4px 0;">
        <strong>Ф.И.О. владельца </strong> Батырбек уулу Алымбек <br />
        <strong>Местоположение:</strong> Чуйская область, Сокулукский район, село Сокулук
<br />
        <strong>Площадь га:</strong> 11,8 га <br />
        <strong> Контакты:</strong>   0778 221 144,
0553 530900
office@agroproduct.kg  
 <br />
      </p>
      <strong> Овощехранилище (обьем /тонн) </strong> 7000 тонн <br />
      <strong> Примечание </strong> Торгово-логистический центр.
Хранение и переработка сельскохозяйственной продукции по голландской технологии, таких как: 
1) мойка калибровка и упаковка
2) хранение овощей и фруктов
3) охлаждение и хранение овощей
4) фасовка, упаковка.
Ассортимент продукции: овощи и плодовые культуры.
Имеется 33 новые холодильные камеры и 10 старые.
Проектная стоимость – 300 млн. сом, 80 тысяч. сом выделил Кыргызско-Российский Фонд Развития.
Создано 20 рабочих мест.
 <br />
      </div>
    `,
    },


    

    {
        latitude: 42.782497, 

        longitude: 74.045620 , 
        tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО
«Кыргыз Центр Продукт»
</h3>
      <p style="margin: 4px 0;">
        <strong>Ф.И.О. владельца </strong> Белошаров Манас <br />
        <strong>Местоположение:</strong> Чуйская область, Московский район,
село Ак-Суу.

<br />
        <strong>Площадь га:</strong> 3 га <br />
        <strong> Контакты:</strong>  0772 571961, 
0312 651600, 
manas7799@mail.ru 

 <br />
      </p>
      <strong> Овощехранилище (обьем /тонн) </strong> 10 000 тонн  <br />
      <strong> Примечание </strong> Торгово-логистический центр.
Хранение, калибровка, и расфасовка овощей 
Имеется 8 холодильных камер по 350 тонн в каждой.
Оборудование и материалы из Голландии.
Заморозка ягодов и овощных культур, броколь капуста и  фасоль.
1,5 млн. долл. – кредит Кыргызско-Российский Фонд Развития и 500 тыс. долл. собственные средства. 
Количество рабочих мест - 20 человек.

 <br />
      </div>
    `,
    },




        {
        latitude: 42.839174, 

        longitude: 74.020300,
        tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО “Дан Агропродукт”
</h3>
      <p style="margin: 4px 0;">
        <strong>Ф.И.О. владельца </strong> Уран Ниязалиев,  <br />
        <strong>Местоположение:</strong> Чуйская область, Московский район, 
село Ак-Суу.


<br />
        <strong>Площадь га:</strong> 5,5 га <br />
        <strong> Контакты:</strong>  0770 770 111
0770 770 580
0312 221 789
office@danagro.com.kg   

 <br />
      </p>
      <strong> Овощехранилище (обьем /тонн) </strong> 15 000 <br />
      <strong> Примечание </strong> Торгово-логистический центр.
Хранения овощей, калибровка, сортировка и расфасовка бобовых культур.
Сумма капитальных вложений: в 2018 году составил 120,0 млн сомов и закуплено оборудование на сумму 105,0 млн сомов; 
2019 году 30,0 млн. сомов (2 этап) строительство завершено.
Количество рабочих мест 100 человек. 


 <br />
      </div>
    `,
    },
    {
        latitude: 42.856509, 

        longitude: 74.343567,
        tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Экопродукт Азия»
</h3>
      <p style="margin: 4px 0;">
       
        <strong>Местоположение:</strong> Чуйская область, Сокулукский район, г.Шопоков, 

<br />
        <strong>Площадь га:</strong> 2 300 кв. м
105 га
 <br />
      </p>
      <strong> Овощехранилище (обьем /тонн) </strong> 40 000  <br />
      <strong> Примечание </strong> Торгово-логистический центр.
Основная деятельность - переработка свежих фруктов, овощей и ягод, и производство соков прямого отжима.
Качественная продукция, высокий сервис.

 <br />
      </div>
    `,
    },

    {
        latitude: 42.852153, 

        longitude: 74.332895,
        tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Дастан Омуралиев»</h3>
      <p style="margin: 4px 0;">
        <strong>Ф.И.О. владельца </strong> Дастан Омуралиев <br />
        <strong>Местоположение:</strong> ул.Первомайская д.26а
<br />
        <strong>Площадь га:</strong>  га <br />
        <strong> Контакты:</strong>  0770 22 10 05
0507 091 337
0702 802 002 
marketing@ecoproduct.kg
 <br />
      </p>
      <strong> Овощехранилище (обьем /тонн) </strong>  тонн <br />
      <strong> Примечание </strong> Единственный производитель соков прямого отжима (NFC) в упаковке Тетра пак в Центральной Азии.
Соки и нектары в уникальном для СНГ формате 65 мл.
Натуральные ингредиенты.  Имеется сертификат - ISO 22000.
Количество рабочих мест 100 человек.

 <br />
      </div>
    `,
    },


    {
        latitude: 42.856403, 

        longitude: 74.121413,
        tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Дар Земли» </h3>
      <p style="margin: 4px 0;">
        <strong>Ф.И.О. владельца </strong> Шамбетова Назгуль Аблабековна <br />
        <strong>Местоположение:</strong> Чуйская область, Московский район, село Беловодское, 
ул. Кирова 32

<br />
        <strong>Площадь га:</strong>  5га <br />
        <strong> Контакты:</strong>  0770 22 10 05
marketing@ecoproduct.kg
 <br />
      </p>
      <strong> Овощехранилище (обьем /тонн) </strong>  1500 <br />
      <strong> Примечание </strong> Торгово-логистический центр.
Осуществляет производство томатной пасты и консервацию овощей.
Инвестиции от Российско-Кыргызского фонда развития составляет 835,0 тыс.долл., в том числе оборудование 335,0 тыс. долл. 
Количество рабочих мест 80 человек.


 <br />
      </div>
    `,
    },

    {
        latitude: 42.784488, 

        longitude: 75.685326,
        tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Копжашаров Кыдыр Тологонович» </h3>
      <p style="margin: 4px 0;">
        <strong>Ф.И.О. владельца </strong> Копжашаров Кыдыр Тологонович <br />
        <strong>Местоположение:</strong> Чуйская область, Московский район, село Беловодское, 
ул. Кирова 32

<br />
        <strong>Площадь га:</strong>  1га <br />
        <strong> Контакты:</strong>  0707 293010
marketing@ecoproduct.kg
 <br />
      </p>
      <strong> Овощехранилище (обьем /тонн) </strong>  210 <br />
      <strong> Примечание </strong> Торгово-логистический центр.
Состоит из трех отдельно стоящих складских помещений для приемки, проверки качества и хранения растениеводческой продукции при температурных режимах 0 С +50С. 
Введен в эксплуатацию  Логистический центр, в рамках проекта ФАО «Наращивание потенциала по укреплению продовольственной безопасности и улучшению питания в ряде стран Кавказа и Центральной Азии», который осуществляется Продовольственной и сельскохозяйственной организацией ООН (ФАО ООН) при финансовом содействии Российской Федерации и техническом содействии Института отраслевого питания (SIFI, РФ). 
Общий объем инвестиций данного проекта составляет 110 тыс. долл., 
Количество рабочих мест 5 человек. 



 <br />
      </div>
    `,
    },

    {
        latitude: 42.887075,

        longitude:  74.860233,
        tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">OcOO “Кант сүт” </h3>
      <p style="margin: 4px 0;">
        <strong>Ф.И.О. владельца </strong> Кадыров Суюндук Кадырович <br />
        <strong>Местоположение:</strong>Чуйская область, г.Кант,  ул. Линейная, 15 

<br />
        <strong>Площадь га:</strong>  14 388.4 квм <br />
        <strong> Контакты:</strong>  0701 505235
0555 422421
0312 60-30-30

 <br />
      </p>
      <strong> Овощехранилище (обьем /тонн) </strong>  40 тонн <br />
      <strong> Примечание </strong> Торгово-логистический центр.
Хранение, распределение, упаковка молока и молочных продукций.
Предприятие занимается производством, переработкой и экспортом сырого молока и готовой молочной продукции.




 <br />
      </div>
    `,
    },

    {
        latitude: 42.824050, 

        longitude:  73.856033,
        tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО “Жайыл милк” </h3>
      <p style="margin: 4px 0;">
        <strong>Ф.И.О. владельца </strong> Абдыразаков Асатилда Абдирашитович <br />
        <strong>Местоположение:</strong>Чуйская область, Жайылский район, город Кара-Балта, ул.Ильича, 109

<br />
        <strong>Площадь га:</strong>  14 388.4 квм <br />
    

 <br />
      </p>
      <strong> Овощехранилище (обьем /тонн) </strong>  40 тонн <br />
      <strong> Примечание </strong> 8.		Чуйская область, Жайылский район, город Кара-Балта, ул.Ильича, 109
	ОсОО “Жайыл милк”
Абдыразаков Асатилда Абдирашитович
	14 388.4 квм	40 тонн	Торгово-логистический центр.
Хранятся: сырое и пастеризованное молоко, сливочное масло, сыры, йогурты и творожная продукция.
Имеется: фасовка и калибровка продукции.
Общая сумма инвестиций и расходов в строительство: 720 715 $
Источник финансирования строительства: РОСФОНД 




 <br />
      </div>
    `,
    },

   
];
const customMarkerIcon = L.icon({
    iconUrl: "/sad.svg",
    iconSize: [35, 55],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
});

export const TLCMap = (props: IContentPart) => {
    (L as any).drawLocal = getCookie("i18next") === "ky" ? KyLokal : RuLokal;

    const [geoData, setGeoData] = useState<any>(null);

    useEffect(() => {
        const fetchGeoData = async (
            file: string,
            setGeoData: React.Dispatch<React.SetStateAction<any>>,
            label: string
        ) => {
            try {
                const response = await fetch(`/${file}`);
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                const data = await response.json();
               
                if (data[0] && data[0].geojson) {
                    setGeoData(data[0].geojson);
                } else {
                    console.warn(
                        `Данные geojson отсутствуют или неверный формат в ${label}:`,
                        data
                    );
                }
            } catch (error) {
                console.error(`Ошибка загрузки данных из ${label}:`, error);
            }
        };

      

        fetchGeoData("polygons/search.json", setGeoData, "polygons/search.json");

    }, []);

    const getStyle = (color: string) => ({
        color: color,
        weight: 2,
        opacity: 1,
        fillOpacity: 0.5,
    });

    const onEachFeature = (feature: any, layer: any) => {
        layer.on({
            mouseover: (e: any) => {
                e.target.setStyle({
                    weight: 4,
                    fillOpacity: 0.7,
                });
            },
            mouseout: (e: any) => {
                e.target.setStyle({
                    weight: 2,
                    fillOpacity: 0.5,
                });
            },
        });
    };

    return (
        <MapContainer
            className={styles.map}
            center={[41.5089324, 74.724091]}
            zoom={7}
            minZoom={7}
            scrollWheelZoom={true}
            zoomControl={false}
        >
    <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
            {/* {geoData && (
        <GeoJSON
          data={geoData}
          style={getStyle("blue")}
          onEachFeature={onEachFeature}
        />
      )} */}

            {markers.map((marker, index) => (
                <Marker
                    key={index}
                    position={[marker.latitude, marker.longitude]}
                    icon={customMarkerIcon}
                >
                    <Popup>
                        <div dangerouslySetInnerHTML={{ __html: marker.tooltip }} />
                    </Popup>
                </Marker>
            ))}
            {geoData && <GeoJSON data={geoData} style={getStyle('grey')} onEachFeature={onEachFeature} />}
          
        </MapContainer>
    );
};
